(function(){
  if (window.__nbInit) return; window.__nbInit = true;
  function reveal(){
    var els = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) {
          var d = en.target.getAttribute('data-delay') || 0;
          setTimeout(function(){ en.target.classList.add('is-in'); }, parseInt(d,10));
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach(function(e){ io.observe(e); });
  }
  function slider(){
    var s = document.getElementById('nb-hslider');
    if (!s) return;
    var yEl = document.getElementById('nb-hy');
    var wEl = document.getElementById('nb-hwin');
    function paint(){
      var v = parseInt(s.value, 10);
      var pct = ((v - s.min) / (s.max - s.min)) * 100;
      s.style.setProperty('--pct', pct + '%');
      if (yEl) yEl.textContent = v;
      if (wEl) wEl.innerHTML = 'Your childhood ran roughly <b>' + (v + 5) + '</b> to <b>' + (v + 16) + '</b>. That is the window we would research for you.';
    }
    s.addEventListener('input', paint);
    paint();
  }
  function boot(){ reveal(); slider(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();